<script>
  let data = $state([
    { x: 10, y: 10, width: 5, height: 40 },
    { x: 10, y: 60, width: 5, height: 40 },
    { x: 10, y: 110, width: 5, height: 40 },
    { x: 10, y: 160, width: 5, height: 40 },
    { x: 10, y: 210, width: 5, height: 40 }
  ]);

  setTimeout(() => {
    data = [
      { x: 10, y: 10, width: 450, height: 40 },
      { x: 10, y: 60, width: 320, height: 40 },
      { x: 10, y: 110, width: 160, height: 40 },
      { x: 10, y: 160, width: 80, height: 40 },
      { x: 10, y: 210, width: 10, height: 40 }
    ];
  }, 4000);
</script>

<div>
  <svg viewBox="0 0 600 300">
    {#each data as d}
      <rect x={d.x} y={d.y} width={d.width} height={d.height} fill="white" />
    {/each}
  </svg>
</div>

<style>
  rect {
    transition: all 1s ease;
  }
</style>
